const organization = {
    title: "Organization",
    search: "Search Organizations...",
    noOrganizations: "Your are not part of any organization",
    file: "File",
}

export default organization;